import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-8 md:pt-24 md:pb-12 overflow-hidden bg-main" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-120">
          {/* Text Content */}
          <div className="order-2 lg:order-1 space-y-8" data-id="element-121">
            <div className="inline-block text-accent text-xs uppercase tracking-widest font-semibold" data-id="element-122">
              MÉTODO FACELESS SPAIN (PDF)
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight text-title" data-id="element-123">
              Tu negocio invisible.
            </h1>

            <p className="text-base text-body max-w-lg leading-relaxed bg-alt inline-block px-3 py-1.5 border border-[#D9D0C1]" data-id="element-124">
              Guía PDF (30 páginas) paso a paso para crear una cuenta faceless y
              vender sin mostrar tu cara.
            </p>

            <ul className="space-y-3 text-body" data-id="element-125">
              <li className="flex items-start" data-id="element-126">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-127" />
                <span data-id="element-128">Sin mostrar tu cara (ni tu nombre si no quieres)</span>
              </li>
              <li className="flex items-start" data-id="element-129">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-130" />
                <span data-id="element-131">Sin bailar, sin cámara frontal, sin exposición</span>
              </li>
              <li className="flex items-start" data-id="element-132">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-133" />
                <span data-id="element-134">
                  Con estructura: qué publicar, qué decir y cómo monetizar
                </span>
              </li>
            </ul>

            <div className="pt-4" data-id="element-135">
              <Button size="lg" withArrow className="w-full sm:w-auto" href="#oferta" data-id="element-136">
                Ver qué incluye
              </Button>
              <p className="text-xs text-body mt-3 flex items-center justify-center sm:justify-start" data-id="element-137">
                PDF 30 páginas • Acceso inmediato • Garantía 14 días
              </p>
            </div>

            <div className="pt-6 border-t border-[#D9D0C1] flex items-center gap-4" data-id="element-138">
              <div className="flex -space-x-2" data-id="element-139">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-[#E7D8C8] border-2 border-[#F6F1E8] overflow-hidden" data-id="element-140">
                    <img src={`https://randomuser.me/api/portraits/women/${40 + i}.jpg`} alt="" className="w-full h-full object-cover grayscale opacity-80" data-id="element-141" />
                  </div>)}
              </div>
              <p className="text-sm text-body" data-id="element-142">
                +450 mujeres ya lo han probado.
              </p>
            </div>
          </div>

          {/* Image Content */}
          <div className="order-1 lg:order-2 relative" data-id="element-143">
            <div className="relative z-10 rounded-sm overflow-hidden shadow-2xl border-8 border-card" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/7BdzpwBVBFR2pt528RXThu/faceless.png" alt="Método Faceless Spain Ebook en tablet y móvil" className="w-full h-auto object-cover" data-id="element-145" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-alt rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-146"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-accent rounded-full mix-blend-multiply filter blur-3xl opacity-10" data-id="element-147"></div>
          </div>
        </div>
      </div>
    </section>;
}